import * as React from 'react';
import Checkbox from '@mui/material/Checkbox';
import FormGroup from '@mui/material/FormGroup';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import { getRandomKey } from '../helpers/base';
import { BaseCheckboxProps } from '../types/global';

const BaseCheckbox = ({
  name,
  label,
  value,
  onChange,
  isDisabled,
}: BaseCheckboxProps) => {
  return (
    <FormControl fullWidth>
      <FormGroup row>
        <FormControlLabel
          onChange={() => onChange({ target: { name, value: !value } })}
          name={name}
          control={<Checkbox sx={{ p: '5px', ml: '7px' }} />}
          key={getRandomKey()}
          value={value === true}
          label={label}
          checked={value === true}
          disabled={isDisabled || false}
        />
      </FormGroup>
    </FormControl>
  );
};

export default BaseCheckbox;
